import Entity from './entity'

export default class SaleOrderDetail extends Entity<number>{
    orderNo: number;
    code: string;
    soDate: Date;
    expectedDeliveryDate: Date;
    handOnDate: Date;
    actualDeliveryDate: Date;
    returnedDate: Date;
    canceledDate: Date;
    canceledBy: number;
    customerName: string;
    customerPhone: string;
    shippingFullAddress: string;
    clientCode: string;
    warehouseCode: string;
    soStatusCode: string;
    inputChannelCode: string;
    bizType: string;
    externalCode: string;
    shippingServiceCode: string;
    tplCode: string;
    totalWeight: number;
    totalVolume: number;
    parentId: number;
    numOfPackage: number;
    isClientPickup: boolean;
    isNoPack: boolean;
    isLabelling: boolean;
    isShippable: boolean;
    outboundMode: string;
    problemNote: string;
    packingNote: string;
    canceledNote: string;
    shippingNote: string;
    creationTime: Date;
    creatorUserId: number;
    creatorUserName: string;
    statusName :string;
    canceledByName :string;
    parentCode :string;
    inputChannelName :string;
    outboundModeName :string;
    clientName:string;
    warehouseName:string;
    isPA:boolean;
    cod:number;
    shippingFee:number;
    tplName:string;
    customerId:number;
    customerCode:string;
    invoiceNo: string;
    shippingServiceName:string;
    pickListCode: string;
    pickListUrl: string;
    confirmPackingNote:string;
    warrantyInfo:string;
    aoGroupCode:string;
    receiverName:string;
    receiverPhone:string;
    customerFullAddress:string;
    toReqId:number;
    canUpdateCommonInfo: boolean;
    packageQty :number;
    packageRTShipQty:number;
    packageShippedQty:number;
    note:string;
    soRequest :any;
    canFinish: boolean;
}